import { useTranslation } from 'react-i18next';

import { useLazyQuery } from "@apollo/client/react";

import { reportAppError } from '@anyx/shared-utils';

import { Option } from '../../line';
import { GET_INFLUENCER_CATEGORIES } from '../graphql';

export type GetInfluencerCategories = () => Promise<Option[]>;

export const useGetInfluencerCategories = () => {
  const [getCategories] = useLazyQuery(GET_INFLUENCER_CATEGORIES);
  const { t } = useTranslation('anychat');

  const getInfluencerCategories: GetInfluencerCategories = async () => {
    try {
      const { data } = await getCategories();

      if (!data || !data.InfluencerCategories) throw new Error('No influencer categories found');

      return data?.InfluencerCategories?.map((category) => ({
        value: category.id,
        label: t('anychat.broadcast.conditions.influencer.categories.options', {
          category: category.id,
        }),
      }));
    } catch (error) {
      reportAppError(error);
      return [];
    }
  };
  return {
    getInfluencerCategories,
  };
};
